import {ThemeColorsHospitalic} from '@/assets/styles/color/ThemeColorsHospitalic'
import styled from 'styled-components'

const StyledSubHeader = styled.div`
    color: ${ThemeColorsHospitalic.TEXT_PRIMARY};
    background-color: transparent;
    font-weight: 600;
    padding-left: 0;
`

export default StyledSubHeader